require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-it-is-for-you.json") })
        }
      }, "path---blog-it-is-for-you");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-it-is-for-you!./.cache/json/blog-it-is-for-you.json
// module id = 894
// module chunks = 231608221292675